
        require('./index.scss');
        'use strict';

require('module/ie-hack');

require('module/jiameng/content');

require('module/jiameng/modal');;
    


// WEBPACK FOOTER //
// ./src/page/jiameng/index.js